module.exports = __webpack_public_path__ + "media/new/contact-suggestion-6e5b3e1d.png";